import { useCallback } from 'react';
import { firebaseApp } from 'firebaseConfig';
import { Auth, getAuth, signInWithCustomToken, signOut } from 'firebase/auth';

export const useFirebaseSignIn = () => {
  const firebaseSignIn = useCallback(async (accessToken: string, auth?: Auth) => {
    if (!auth) auth = getAuth(firebaseApp);

    try {
      await signInWithCustomToken(auth, accessToken);
    } catch (error) {
      await signOut(auth);

      throw error;
    }
  }, []);

  return {
    firebaseSignIn,
  };
};
